export default "__VITE_ASSET__DPo8Um$n__"